import script from "./ChannelFlowSourceImport.vue?vue&type=script&setup=true&lang=js"
export * from "./ChannelFlowSourceImport.vue?vue&type=script&setup=true&lang=js"

import "./ChannelFlowSourceImport.vue?vue&type=style&index=0&id=013cd486&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-013cd486"]])

export default __exports__